/**
 * Jewellery Box
 */

const JewelleryBox = (function($) {
  "use strict";

  function init() {
    // return early if no corresponding module present
    if (!$(".JewelleryBox").length) {
      return;
    }

    $(".JewelleryBox-carousel").slick({
      infinite: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ],
      slidesToShow: 3,
      speed: 800
    });
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(JewelleryBox.init);
